import React from "react";
import { DisplaySmall, spacing } from "@conserveit/blocks";
import PropTypes from "prop-types";
import styled from "styled-components";

const StyledDisplaySmall = styled(DisplaySmall)`
  position: relative;
  text-align: center;
  margin-bottom: ${spacing.default};

  &:after {
    margin-left: auto;
    content: "";
  }
`;

const InfoText = ({ ruleName }) => (
  <StyledDisplaySmall>
    <strong>Rule: {ruleName}</strong>
  </StyledDisplaySmall>
);

InfoText.propTypes = {
  ruleName: PropTypes.string.isRequired,
};

export default InfoText;
